import React from "react";
import theme from "theme";
import { Theme, Box, Section, Text } from "@quarkly/widgets";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";

import {
  Timeline,
  Events,
  ImageEvent,
  YouTubeEvent,
  themes,
  createTheme,
} from "@merc/react-timeline";

import image_history_larryzhonggreenhouse from "../assets/images_history/larryzhong_greenhouse.jpg";
import image_history_redsolarrobot from "../assets/images_history/redsolarrobot.png";
import image_history_redsolarpro2 from "../assets/images_history/redsolarprototype2.png";
import image_history_solspacesgreenhousebuild from "../assets/images_history/solspaces_greenhousebuild.jpg";
import image_history_solarlockerdesign from "../assets/images_history/solarlockerdesign.png";
import image_history_solarlockerbuild from "../assets/images_history/20200831_163336.jpg";
import image_history_greenhouseunveiled from "../assets/images_history/solargreenhouseunveiled.jpg";
import image_history_greenhouseglobalnews from "../assets/images_history/solargreenhouseglobalnews.png";
import image_history_greenhousedrawing from "../assets/images_history/solargreenhousedrawing2.png";

const customColor_Green = "#00d821";
const customThemeTimeline = createTheme(themes.default, {
  card: {
    backgroundColor: "#56666f",
    color: "white",
  },
  date: {
    backgroundColor: customColor_Green,
    color: "#0E1317",
  },
  marker: {
    borderColor: customColor_Green,
  },
  timelineTrack: {
    backgroundColor: customColor_Green,
  },
});

export default () => {
  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"index"} />
      <Components.CombinedHelmetNHeader />
      <Section
        padding="60px 0 0px 0"
        md-padding="30px 0 0px 0"
        quarkly-title="Section_PP_Content2"
      >
        <Override
          slot="SectionContent"
          flex-direction="row"
          md-flex-wrap="wrap"
        />
        <Box
          empty-min-width="64px"
          padding="0px 0px 0px 0px"
          md-padding="0px 0px 0px 0px"
          md-width="100%"
          width="100%"
          lg-padding="0px 28px 0px 0px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          margin="0px 0px 0px 0px"
        >
          <Text
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-font="normal 500 28px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            margin="0px 0px 12px 0px"
            color="--green"
          >
            History of the Club
          </Text>
          <Text
            color="--light"
            font="--base"
            text-align="left"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            md-margin="0px 0px 16px 0px"
            margin="0px 0px 0px 0px"
          >
            RED was founded back in 2017 by a group of UAlberta engineering
            students who wanted to get hands on experience with renewable energy
            systems, research its feasibility, and spread awareness of green
            technology to others at the university.
            <br />
            <br />
            The club started with small projects, but quickly built ambition to
            create larger and more complex projects:
          </Text>
        </Box>
      </Section>

      <Section
        padding="60px 0 60px 0"
        md-padding="30px 0 30px 0"
        quarkly-title="Section_PP_Content4"
      >
        {/* Timeline component comes from @merc's Timeline lib, docs here: https://react-timeline.com/?path=/docs/timeline-theming-intro--page */}
        <Timeline theme={customThemeTimeline}>
          <Events>
            <ImageEvent
              date="August 2017 - RED is founded"
              text="Engineering students, lead by Larry Zhong *(photo)*, 
              form a club with the goal of shaping their own minds within the realm of green technology, 
              and inspiring the minds of others at the university."
              src={image_history_larryzhonggreenhouse}
              credit="[Photo by UAlberta](https://www.ualberta.ca/en/sustainability/about/news-profiles/2021/10-october/the-power-is-finally-on-at-the-campus-solar-greenhouse.html)"
            ></ImageEvent>
            <ImageEvent
              date="Late 2017 - Solar projects are started, ideas grow"
              text="The club conceives of idea to host workshops for building solar powered robots. 
              The club also researches the possibility of supporting installations of solar panels and wind turbines around campus. 
              The club also looks into what renewables-themed competitions they can join or make."
              src={image_history_redsolarrobot}
            ></ImageEvent>
            <ImageEvent
              date="Mid 2018 - A prototype is brewing..."
              text="RED starts building a prototype of the small-scale solar charger, with new consideration for a modular design."
              src={image_history_redsolarpro2}
            ></ImageEvent>
            <YouTubeEvent
              date="October 2018 - Unveiling the small-scale solar charger! A dream-made-real..."
              text="The first assembled prototype is unveiled to the university. RED members are excited to manifest their physical product."
              id="z5a3yZCjA5M" // YouTube video ID, i.e.: https://www.youtube.com/watch?v=z5a3yZCjA5M
            />
            <ImageEvent
              date="2019 - Winds are blowing... A shining partnership is growing..."
              text="RED shifts gears to focus on participating in their first wind design competition in the hopes to finds a good small-scale wind turbine prototype.
              The clubs also plans on their upgrading of the small-scale solar charger and campus placement.
              The club advances their plans to build a net-zero building by reaching out to builders Sol Spaces, and seeking grants from EMSO."
            ></ImageEvent>
            <ImageEvent
              date="Early 2020 - Solar greenhouse project is getting serious, calculations are made"
              text="RED solidifies their commitment to three projects: an upgraded version of their small-scale solar charger, 
              with the intent of installing it within SUB; a wind turbine prototype, sprouted from a student compeitition, 
              and the net-zero solar greenhouse being planned (with things like thermal modeling, and heat pump planning)."
              src={image_history_greenhousedrawing}
            ></ImageEvent>
            <ImageEvent
              date="Mid-2020 - Small-scale solar charger, version 2 plan is designed"
              text="RED finishes their plans for the upgraded version of their small-scale solar charger, a version with 6 phone lockers and larger solar panel set."
              src={image_history_solarlockerdesign}
            ></ImageEvent>
            <YouTubeEvent
              date="June 2020 - Wind turbine competition makes a force!"
              text="RED executes the wind turbine competition, with judges picking the Savonius-style vertical axis 'Feuerstrom' (Fire Stream) as the winner!."
              id="004tmN2Emro" // YouTube video ID
            />
            <ImageEvent
              date="August 2020 - The solar locker is unveiled!"
              text="RED completes assembly of their version 2 solar charger, the solar charger phone locker!"
              src={image_history_solarlockerbuild}
            ></ImageEvent>
            <YouTubeEvent
              date="Early 2021 - Solar greenhouse engineered planned is finalized"
              text="RED finishes their greenhouse plans, and now it's Sol Spaces time to shine!"
              id="gYfyrouz5U0" // YouTube video ID
            />
            <ImageEvent
              date="Summer 2021 - Solar greenhouse is being built"
              text="Sol Spaces is doing a fantastic job of building the greenhouse. 
              Elliott Putters from Exceed Solar (alongside RED's leader, Larry) is showing off the progress of the build. "
              src={image_history_solspacesgreenhousebuild}
              credit="[Photo by Sol Spaces, at their Facebook page](https://www.facebook.com/photo/?fbid=370277124826811&set=a.332923191895538)"
            ></ImageEvent>
            <ImageEvent
              date="August 2021 - Solar greenhouse is unveiled!"
              text="Sol Spaces finishes the build of the solar greenhouse, and the club is excited to show it off to the university.
              * Riley Tjosvold created an informative article of the greenhouse, which can be found at the source link below. * "
              src={image_history_greenhouseunveiled}
              credit="[Article by Riley Tjosvold, on UAlberta's Sustainability Council webpage](https://www.ualberta.ca/en/sustainability/about/news-profiles/2021/10-october/the-power-is-finally-on-at-the-campus-solar-greenhouse.html)"
            ></ImageEvent>
            <ImageEvent
              date="October 2021 - Our solar greenhouse is featured on Global News!"
              text="Global News Edmonton features our solar greenhouse in their news segment, giving a video tour of the space. * Click the source link below! * "
              src={image_history_greenhouseglobalnews}
              credit="[Article by Global News at their website.](https://globalnews.ca/video/8251285/high-tech-solar-greenhouse-at-university-of-alberta/)"
            ></ImageEvent>

            {/* //example events: image (and button), text, youtube video
            <TextEvent date="January 2017" text="**Markdown** is *supported*" />
            <ImageEvent
              date="4/13/19"
              text="You can embed images..."
              src="https://res.cloudinary.com/dovoq8jou/image/upload/v1564772194/jellyfish.jpg"
              alt="jellyfish swimming"
              credit="Photo by [@tavi004](https://unsplash.com/@tavi004)"
            >
              <div>
                <UrlButton href="https://unsplash.com/search/photos/undersea">
                  View more undersea photos
                </UrlButton>
              </div>
            </ImageEvent>
            <TextEvent
              date="Late 2017"
              text="Engineering students form a club hoping to 
              shape their own minds within the realm of green technology, 
              and shape the minds of others at the university."
            />
            <YouTubeEvent
              date="6/18/19"
              id="6UnRHtwHGSE"
              name="General Tso's Chicken recipe"
              text="... and YouTube videos!"
            /> */}
          </Events>
        </Timeline>
      </Section>

      <Section
        padding="0px 0 0px 0"
        md-padding="0px 0 0px 0"
        quarkly-title="Section_PP_Content2"
      >
        <Override
          slot="SectionContent"
          flex-direction="row"
          md-flex-wrap="wrap"
        />
        <Box
          empty-min-width="64px"
          padding="0px 0px 0px 0px"
          md-padding="0px 0px 0px 0px"
          md-width="100%"
          width="100%"
          lg-padding="0px 28px 0px 0px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          margin="0px 0px 0px 0px"
        >
          <Text
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-font="normal 500 28px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            margin="0px 0px 12px 0px"
            color="--green"
          >
            Add more stuff...
          </Text>
          <Text
            color="--light"
            font="--base"
            text-align="left"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            md-margin="0px 0px 16px 0px"
            margin="0px 0px 0px 0px"
          >
            Add more about majors updates with club (blurb about WIRE giving us tour of largest on-meter solar farm),
             and projects solar (IoT systems, novalynx), wind turbine (prototype made, and braking systems), 
             and thermal storage. anythign else? 
          </Text>
        </Box>
      </Section>

      <Components.CustomFooter />
      <RawHtml>
        <style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
          {
            ":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"
          }
        </style>
      </RawHtml>
    </Theme>
  );
};
